"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showPopover = showPopover;
exports.hidePopover = hidePopover;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function showPopover(popover, e) {
  var boundingRect = e.currentTarget.getBoundingClientRect();
  return _objectSpread({}, popover, {
    visible: true,
    parentRect: boundingRect
  });
}

function hidePopover(popover) {
  return _objectSpread({}, popover, {
    visible: false
  });
}

function getPopoverStyle(rect, position) {
  if (position === 'top') {
    return {
      bottom: window.innerHeight - rect.top + 15,
      left: rect.left + rect.width / 2,
      transform: 'translateX(-50%)'
    };
  } else if (position === 'bottom') {
    return {
      top: rect.bottom + 15,
      left: rect.left + rect.width / 2,
      transform: 'translateX(-50%)'
    };
  } else if (position === 'left') {
    return {
      top: rect.bottom - rect.height / 2,
      right: window.innerWidth - rect.left + 15,
      transform: 'translateY(-50%)'
    };
  } else {
    return {
      top: rect.bottom - rect.height / 2,
      left: rect.right + 15,
      transform: 'translateY(-50%)'
    };
  }
}

var className = function className(props) {
  return (0, _classnames.default)('Popover', {
    'Popover--visible': props.visible
  }, {
    'Popover--top': props.position === 'top',
    'Popover--left': props.position === 'left',
    'Popover--right': props.position === 'right',
    'Popover--bottom': props.position === 'bottom'
  }, {
    'Popover--padded': props.paddedContent
  }, props.className);
};

var PopoverElement = function PopoverElement(props) {
  // const { children, visible, style, paddedContent, position } = this.props;
  var children = props.children,
      style = props.style;
  return _react.default.createElement("div", {
    className: className(props),
    style: style,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, _react.default.createElement("div", {
    className: "Popover__wrapper",
    "data-element": "wrapper"
  }, _react.default.createElement("div", {
    className: "Popover__content"
  }, children), _react.default.createElement("div", {
    className: "Popover__tip"
  })));
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));
    _this._handleClickClose = _this._handleClickClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._handleScrollClose = _this._handleScrollClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var wasVisible = prevProps.visible;
      var visible = this.props.visible;

      if (!wasVisible && visible) {
        document.addEventListener('click', this._handleClickClose);
        document.addEventListener('scroll', this._handleScrollClose);
      } else if (wasVisible && !visible) {
        document.removeEventListener('click', this._handleClickClose);
        document.removeEventListener('scroll', this._handleScrollClose);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this._handleClickClose);
      document.removeEventListener('scroll', this._handleScrollClose);
    }
  }, {
    key: "_handleClickClose",
    value: function _handleClickClose(e) {
      var _this$props = this.props,
          onClickClose = _this$props.onClickClose,
          visible = _this$props.visible,
          label = _this$props.label,
          exitOnClick = _this$props.exitOnClick;

      if (this.popover) {
        if (!!visible && (e.target !== this.popover && !this.popover.contains(e.target) || exitOnClick)) {
          onClickClose(label);
        }
      }
    }
  }, {
    key: "_handleScrollClose",
    value: function _handleScrollClose() {
      var _this$props2 = this.props,
          onClickClose = _this$props2.onClickClose,
          visible = _this$props2.visible,
          label = _this$props2.label;

      if (visible) {
        onClickClose(label);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          visible = _this$props3.visible,
          parentRect = _this$props3.parentRect,
          side = _this$props3.position,
          text = _this$props3.text;
      var position = side || 'top';
      var popoverStyle = parentRect ? getPopoverStyle(parentRect, position) : null;
      return _reactDom.default.createPortal(_react.default.createElement(PopoverElement, {
        visible: visible,
        style: popoverStyle,
        paddedContent: text,
        position: position
      }, _react.default.createElement("div", {
        ref: function ref(popover) {
          return _this2.popover = popover;
        }
      }, children)), document.body);
    }
  }]);

  return Popover;
}(_react.default.Component);

var _default = Popover;
exports.default = _default;